import { render, staticRenderFns } from "./AgencyChooseGeographicalLocationReadOnlyView.vue?vue&type=template&id=74669d0a&scoped=true&"
import script from "./AgencyChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./AgencyChooseGeographicalLocationReadOnlyView.vue?vue&type=style&index=0&id=74669d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74669d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
